import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from "react";
import { MeDialog } from "@/components/profile/MeDialog";

type MeDialogContextValue = {
  open: boolean;
  setOpen: (open: boolean) => void;
  openMe: () => void;
};

const MeDialogContext = createContext<MeDialogContextValue | null>(null);

export function MeDialogProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const openMe = useCallback(() => setOpen(true), []);
  const value = useMemo(() => ({ open, setOpen, openMe }), [open, openMe]);

  return (
    <MeDialogContext.Provider value={value}>
      {children}
      <MeDialog open={open} onOpenChange={setOpen} />
    </MeDialogContext.Provider>
  );
}

export function useMeDialog() {
  const ctx = useContext(MeDialogContext);
  if (!ctx) throw new Error("useMeDialog 须在 MeDialogProvider 内使用");
  return ctx;
}
